import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-table-plan-annual-price',
  template: `
    <div>
      <div>
        <span class="price-label">
          $<span>{{base_val}}</span>
          <sup *ngIf="cent_val!=00" style="font-size: 10px;">{{cent_val}}</sup>
          <span>/mo</span>
      </span>

      </div>
    </div>`,
  styles: []
})
export class TablePlanAnnualPriceComponent implements OnInit {

  @Input() rowData: any;

  base_discount_plan_price: any;
  base_val: any;
  cent_val: any;

  ngOnInit() {
    // this.base_discount_plan_price = '$' + (this.rowData.plan_price - (+this.rowData.actual_plan_price) * 30 / 100) + '/mo';
    this.base_discount_plan_price =  (this.rowData.plan_price - (+this.rowData.actual_plan_price) * 30 / 100).toFixed(2);
    let base_price = this.base_discount_plan_price;

    base_price = base_price.toString();
    base_price = base_price.split('.');

    this.base_val = base_price[0];
    this.cent_val = base_price[1];
  }

}
